import { useCountryLabel } from "@/shared/hooks/useCountryLabel";

import { COUNTRY_OPTIONS } from "../constants/clients.constants";

export interface CountryLabelProps {
  /** ISO 3166-1 alpha-3 country code as stored by the backend (e.g. "COL"). */
  code: string | null | undefined;
  className?: string;
}

const OPTION_BY_ISO3 = new Map(COUNTRY_OPTIONS.map((option) => [option.value, option]));

/** Flag + localized country name resolved from the backend's ISO-3 code. Falls back to an em dash. */
export function CountryLabel({ code, className }: CountryLabelProps) {
  const countryLabel = useCountryLabel();
  const option = code ? OPTION_BY_ISO3.get(code.trim().toUpperCase()) : undefined;
  if (!option) {
    return <span className={className}>—</span>;
  }
  return (
    <span className={className ?? "inline-flex items-center gap-2 text-sm text-muted-foreground"}>
      {option.iso2 && (
        <img
          src={`https://flagcdn.com/${option.iso2.toLowerCase()}.svg`}
          alt=""
          aria-hidden="true"
          loading="lazy"
          className="h-3.5 w-5 shrink-0 rounded-[2px] object-cover"
        />
      )}
      {countryLabel(option.value, option.label)}
    </span>
  );
}
